// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollToTop_wrapper__ytic7"};